export const PlaceholderContent = {
    LOGIN_PAGE: {
        SignUp: "e.g., 9XX26XX65",
        SignIn: "Mobile Number"
    },
    SIGNUP_STEPS: {
        PanCard: "e.g., AAAAA9999A",
        GSTIN: "e.g., 22AAAAA0000A1Z5",
        OtherCategory:'Enter Business Category',
        BusinessName: "Enter Business Name",
        BusinessDescription: "e.g., Capturing timeless moments with elegance and artistry, we specialize in creating stunning visual narratives that celebrate love and joy.",
        BusinessAddress: "Enter Business Address",
        ContactPerson: "e.g., John"
    },
    BUSINESS_INFO_PAGE: {
        GSTIN: 'e.g., 22AAAAA0000A1Z5',
        PAN: "Enter the PAN",
        PinCode: "Enter Pin Code",
        BusinessName: "Enter Business Name",
        BusinessDescription: "Enter Business Description",
        BusinessAddress: "Enter Business Address",
        ContactPerson: "Enter Your Name",
        Instagram: "Instagram URL",
        Facebook: "Facebook URL",
        Website: "Enter Website URL",
        BusinessLocation: "e.g., https://maps.app.goo.gl/K9eKWgAANgbP3hFD6",
        LocationPopup: "https://www.google.com/maps/place/Your+Business+Location+Here"
    },
    BILLING_ADDRESS: {
        Name: "Enter Your Name",
        State: "Select State",
        BusinessAddress: "Enter Business Address",
        BillingAddress: "Enter Billing Address",
        Area: "Enter Area",
        Landmark: "Enter Landmark",
        TownCity: "Enter Town/City",
        PinCode: "Enter Pin Code"
    },
    AD_CREATION: {
        Instagram: "https://www.instagram.com/yourprofile/",
        Facebook: "https://www.facebook.com/yourpage/",
        Direction: "https://www.google.com/maps/place/Your+Business+Location+Here"
    },
    CATALOG_CREATION: {
        Title: "Enter Title",
        Description: "Enter Description",
        Price: "Enter Price"
    },
    CHANGE_PHONE_NUMBER: {
        ChangePhoneNumber: "Change Mobile Number",
        EnterNewMobileNumber: "Enter New Mobile Number"
    }
};
